import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconProfileSvg } from "./IconProfileSvg.mjs";
const IconProfile = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconProfileSvg, ...svgProps }) });
export {
  IconProfile
};
